import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@jordan/theme/limitless.css';
import './styles.css';
// Bootstrap 5 vanilla JS (dropdowns, collapse, offcanvas) — matches the Limitless theme.
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
